
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.75 7a3.25 3.25 0 116.5 0 3.25 3.25 0 01-6.5 0zM9 2.25a4.75 4.75 0 100 9.5 4.75 4.75 0 000-9.5zM4.702 16.702A3.25 3.25 0 017 15.75h4A3.25 3.25 0 0114.25 19v1.4a.75.75 0 001.5 0V19A4.75 4.75 0 0011 14.25H7A4.75 4.75 0 002.25 19v1.4a.75.75 0 001.5 0V19c0-.862.342-1.689.952-2.298zM15.05 4.4a.75.75 0 01.75-.75 3.75 3.75 0 110 7.5.75.75 0 010-1.5 2.25 2.25 0 100-4.5.75.75 0 01-.75-.75zm1.75 9.85a.75.75 0 000 1.5h.364a2.886 2.886 0 012.886 2.886v1.273a.75.75 0 001.5 0v-1.273a4.386 4.386 0 00-4.386-4.386H16.8z"}})])
          )
        }
      }
    